<template>
  <div class="page">
    <ion-grid>
      <ion-row class="row-divider"></ion-row>
      <ion-row class="search-view">
        <ion-col>
          <ion-row align-items-stretch>
            <ion-col size="12" size-md="3">
              <ion-label>Reservation No</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input class="form-input" type="text" id="id" @input="id = $event.target.value"></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Charging Station</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="stationName"
                  @input="stationName = $event.target.value"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Customer Name/Mobile</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="customerName"
                  @input="customerName = $event.target.value"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Status</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-select
                  class="form-select select-mobile"
                  :value="status"
                  @ionChange="status = $event.target.value"
                  placeholder="Select Status"
                  interface="action-sheet"
                >
                  <ion-select-option
                    v-for="(status, index) in this.statuses"
                    :key="index"
                    :value="status.id"
                  >{{status.name}}</ion-select-option>
                </ion-select>

                <select
                  class="input-select select-web"
                  v-model="status"
                  placeholder="Select Status"
                >
                  <option
                    v-for="(status, index) in this.statuses"
                    :key="index"
                    :value="status.id"
                  >{{ status.name }}</option>
                </select>
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Reservation Date From</ion-label>
              <div class="date-picker-box margin-top-10 datepicker-web">
                <datepicker
                  class= "form-vue-picker"
                  placeholder= "DD/MON/YYYY"
                  inputFormat="dd/MMM/yyyy"
                  v-model= "reservFrom"
                  :typeable= "true"
                ></datepicker>
                <span class="custom-calendar-icon">
                  <img src="/../assets/images/common/datepicker/calendar.png" />
                </span>
              </div>
              <div class="border-line-34 margin-top-10 datepicker-mobile">
                <!-- <div class="input-icon-calendar"> -->
                  <!-- <ion-datetime
                    class="form-picker"
                    placeholder="Select From Date"
                    displayFormat="YYYY, MM, DD"
                    @ionChange="reservFrom = $event.target.value"
                  ></ion-datetime> -->
                  <datepicker
                    class= "form-picker"
                    placeholder= "Select From Date"
                    inputFormat="MMM dd, yyyy"
                    v-model= "reservFrom"
                    :typeable= "true"
                ></datepicker>
                <span class="input-icon-calendar">
                    <img src="/../assets/images/common/datepicker/calendar.png" />
                  </span>
                <!-- </div> -->
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Reservation Date To</ion-label>
              <div class="date-picker-box margin-top-10 datepicker-web">
                <datepicker
                  class= "form-vue-picker"
                  placeholder= "DD/MON/YYYY"
                  inputFormat="dd/MMM/yyyy"
                  v-model= "reservTo"
                  :typeable= "true"
                ></datepicker>
                <span class="custom-calendar-icon">
                  <img src="/../assets/images/common/datepicker/calendar.png" />
                </span>
              </div>
              <div class="border-line-34 margin-top-10 datepicker-mobile">
                <!-- <div class="input-icon-calendar"> -->
                  <!-- <ion-datetime
                    class="form-picker"
                    placeholder="Select To Date"
                    displayFormat="YYYY, MM, DD"
                    @ionChange="reservTo = $event.target.value"
                  ></ion-datetime> -->
                  <datepicker
                    class= "form-picker"
                    placeholder= "Select To Date"
                    inputFormat="MMM dd, yyyy"
                    v-model= "reservTo"
                    :typeable= "true"
                ></datepicker>
                <span class="input-icon-calendar">
                    <img src="/../assets/images/common/datepicker/calendar.png" />
                  </span>
                <!-- </div> -->
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Invoice Date From</ion-label>
              <div class="date-picker-box margin-top-10 datepicker-web">
                <datepicker
                  class="form-vue-picker"
                  placeholder="DD/MON/YYYY"
                  inputFormat="dd/MMM/yyyy"
                  v-model="invoiceFrom"
                  :typeable="true"
                ></datepicker>
                <span class="custom-calendar-icon">
                  <img src="/../assets/images/common/datepicker/calendar.png" />
                </span>
              </div>
              <div class="border-line-34 margin-top-10 datepicker-mobile">
                <!-- <div class="input-icon-calendar"> -->
                  <!-- <ion-datetime
                    class="form-picker"
                    placeholder="Select From Date"
                    displayFormat="YYYY, MM, DD"
                    @ionChange="invoiceFrom = $event.target.value"
                  ></ion-datetime> -->
                  <datepicker
                    class= "form-picker"
                    placeholder= "Select From Date"
                    inputFormat="MMM dd, yyyy"
                    v-model= "invoiceFrom"
                    :typeable= "true"
                ></datepicker>
                <span class="input-icon-calendar">
                    <img src="/../assets/images/common/datepicker/calendar.png" />
                  </span>
                <!-- </div> -->
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Invoice Date To</ion-label>
              <div class="date-picker-box margin-top-10 datepicker-web">
                <datepicker
                  class="form-vue-picker"
                  placeholder="DD/MON/YYYY"
                  inputFormat="dd/MMM/yyyy"
                  v-model="invoiceTo"
                  :typeable="true"
                ></datepicker>
                <span class="custom-calendar-icon">
                  <img src="/../assets/images/common/datepicker/calendar.png" />
                </span>
              </div>
              <div class="border-line-34 margin-top-10 datepicker-mobile">
                <!-- <div class="input-icon-calendar"> -->
                  <!-- <ion-datetime
                    class="form-picker"
                    placeholder="Select To Date"
                    displayFormat="YYYY, MM, DD"
                    @ionChange="InvoiceTo = $event.target.value"
                  ></ion-datetime> -->
                  <datepicker
                    class= "form-picker"
                    placeholder= "Select To Date"
                    inputFormat="MMM dd, yyyy"
                    v-model= "invoiceTo"
                    :typeable= "true"
                ></datepicker>
                <span class="input-icon-calendar">
                    <img src="/../assets/images/common/datepicker/calendar.png" />
                  </span>
                <!-- </div> -->
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <ion-label>Invoice No</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="invoiceNo"
                  @input="invoiceNo = $event.target.value"
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="3">
              <br />
              <ion-button class="btn-search margin-top-10" @click="searchReservations">Search</ion-button>
              <ion-button class="btn-clear margin-top-10" @click="clearFields">
                <ion-icon :icon="refresh"></ion-icon>
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row class="list-view">
        <ion-col>
          <ion-row class="list-head">
            <ion-col size="12" size-md="1">
              <ion-label>Res.No</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Charging Station</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Name</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Mobile</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Res.Date</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Inv. #</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Inv. Date</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Inv. Total</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>kWh</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Status</ion-label>
            </ion-col>
          </ion-row>
          <hr />
          <ion-row class="list-item" v-for="(reservation) in this.reservations" :key="reservation">
            <ion-col size="12" size-md="1">
              <ion-label
                class="ext-link"
                @click="viewReservation(reservation.id)"
              >{{reservation.refNo}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>{{reservation.station.name}}</ion-label>
            </ion-col>
            <ion-col class="limit-length" size="12" size-md="2">
              <ion-label>{{reservation.customer.profile.firstName}} {{reservation.customer.profile.lastName}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>{{reservation.customer.profile.mobile}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>{{changeDateFormat(reservation.slot.startsOn)}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>{{reservation.invoice.invoiceNo}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>{{changeDateFormatWithoutTime(reservation.invoice.invoiceOn)}}</ion-label>
            </ion-col>
            <!-- Below code commented by vinoth because expecting amount should display with paise but it is displaying only round of amount  -->
            <!-- <ion-col size="12" size-md="1">
              <ion-label>{{reservation.invoice.invoiceAmount}}</ion-label>
            </ion-col> -->
            
             <ion-col size="12" size-md="1">
              <ion-label v-if="reservation.invoice.invoiceAmount == null">{{reservation.invoice.invoiceAmount}}</ion-label>
              <ion-label v-if="reservation.invoice.invoiceAmount != null">{{reservation.invoice.invoiceAmount.toFixed(2)}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label v-if="reservation.commercial.actual">{{reservation.commercial.actual.unit}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label
                style="white-space: nowrap;"
                class="status-small"
                v-bind:class="[{'open': reservation.status.id === 'O'}, {'cancelled': reservation.status.id === 'X'}, {'wip': reservation.status.id === 'P'}, {'expired': reservation.status.id === 'E'}, {'completed': reservation.status.id === 'C'}]"
              >{{convertUppercase(reservation.status.name)}}</ion-label>
              </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row v-if="norecordsfound">
        <ion-col size="12" class="ion-text-center">
          <ion-label class="pagination-info">No records found for the selected filters</ion-label>
        </ion-col>
      </ion-row>
      <ion-row v-else>
        <ion-col size="12" size-md="5">
          <ion-label
            class="pagination-info"
          >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
        </ion-col>
        <ion-col size="12" size-md="7" class="ion-text-right">
          <div class="pagination">
            <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
            <a class="prev disabled" v-else>Prev</a>
            <a
              
              v-for="page in this.pagesList"
              :key="page"
              v-bind:class="{'active': pageNo == page}"
              @click="loadPage(page)"
            >{{page}}</a>
            <a
              
              class="next"
              v-if="this.pageNo < this.totalPages"
              @click="loadPage(pageNo + 1)"
            >Next</a>
            <a href="#" class="next disabled" v-else>Next</a>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { EVCStationReservationService } from "../../service/evcstation/reservation.service";
import { EVChargingReservationStatus } from "@/entity/station/reservation";

import { LocalStorage } from "../../data/localstorage";
import { ToastUtils } from "../../util/toast-utils";
import { migratedTryParseServiceError } from "../../service";
import { PaginationUtils } from "../../util/pagination-utils";
import { refresh } from 'ionicons/icons';
// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import datepicker from 'vue3-datepicker';
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
import moment from "moment";

export default defineComponent ({
  name: 'reservations',
  components: {
    datepicker, IonIcon, IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSelect, IonSelectOption, IonButton, IonSpinner
  },
  data() {
    return {
      refresh,
      loaderTab: true,
      reservations: [],
      statuses: [],
      types: [],
      statusModels: [],
      typeModels: [],
      id: "",
      stationName: "",
      customerName: "",
      reservationType: "",
      reservFrom: "",
      reservTo: "",
      status: "",
      invoiceFrom: "",
      invoiceTo: "",
      invoiceNo: "",

      norecordsfound: true,
      totalRecords: 0,
      pageRecords: 10,
      pageNo: 1,
      pagesList: [],
      totalPages: 0,
    }
  },
  async mounted() {
    try {
      this.types = await new EVCStationReservationService().reservationTypes();
      this.statuses = await new EVCStationReservationService().reservationStatuses();

      this.statusModels = [];
      this.statuses.forEach((status) => {
        this.statusModels.push({
          text: status.name,
          value: status.id,
        });
      });

      this.typeModels = [];
      this.types.forEach((type) => {
        this.typeModels.push({
          text: type.info.name,
          value: type.info.id,
        });
      });

      var page = localStorage.getItem("reservationPage");
      if (page) {
        this.pageNo = Number(page);
      }
      var search = localStorage.getItem("reservationSearch");
      if (search) {
        search = JSON.parse(search);
        this.id = search.id;
        this.stationName = search.stationName;
        this.customerName = search.customerName;
        document.getElementById("id").value = search.id;
        document.getElementById("stationName").value = search.stationName;
        document.getElementById("customerName").value = search.customerName;
        this.reservationType = search.reservationType;
        this.reservFrom = search.reservFrom;
        this.reservTo = search.reservTo;
        this.status = search.status;
        this.invoiceFrom = search.invoiceFrom;
        this.invoiceTo = search.invoiceTo;
        this.invoiceNo = search.invoiceNo;

        await this.searchReservations();
      }
      this.loaderTab = false;
    } catch(error) {
      this.loaderTab = false;
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
    }
    
  },

  methods: {
    changeDateFormat(dateValue) {
      return moment(dateValue).format('DD/MMM/YYYY HH:mm')
    },
    changeDateFormatWithoutTime(dateValue) {
      
      if(dateValue != null) {
        return moment(dateValue).format('DD/MMM/YYYY')
      }
      
    },
    convertUppercase(value) {
      return value.toUpperCase()
    },
    viewReservation(reservationId) {
      this.$router.push({
        name: "reservationView",
        params: { reservationId: reservationId },
      });
    },
    clearFields() {
      this.id = null;
      this.stationName = null;
      this.customerName = null;
      document.getElementById("id").value = null;
      document.getElementById("stationName").value = null;
      document.getElementById("customerName").value = null;
      this.reservationType = null;
      this.reservFrom = null;
      this.reservTo = null;
      this.status = null;
      this.invoiceFrom = null;
      this.invoiceTo = null;
      this.invoiceNo = null;

      localStorage.removeItem("reservationSearch");
      localStorage.removeItem("reservationPage");
      this.reservations = [];
      this.norecordsfound = true; //Modified by Swide on 2020-12-16 Bug#3 
    },
    async searchReservations() {
      try {
        localStorage.setItem(
        "reservationSearch",
        JSON.stringify({
          id: this.id,
          stationName: this.stationName,
          customerName: this.customerName,
          reservationType: this.reservationType,
          reservFrom: this.reservFrom,
          reservTo: this.reservTo,
          status: this.status,
          invoiceFrom: this.invoiceFrom,
          invoiceTo: this.invoiceTo,
          invoiceNo: this.invoiceNo,
        })
        );
        if (
          this.reservFrom &&
          this.reservTo &&
          new Date(this.reservFrom) > new Date(this.reservTo)
        ) {
          new ToastUtils().presentToast(
            "Please select correct date range of Reservation. From date should less than To date"
          );
          this.reservations = [];
          this.norecordsfound = true;
        } else if (
          this.invoiceFrom &&
          this.invoiceTo &&
          new Date(this.invoiceFrom) > new Date(this.invoiceTo)
        ) {
          new ToastUtils().presentToast(
            "Please select correct date range of Invoice. From date should less than To date"
          );
          this.reservations = [];
          this.norecordsfound = true;
        } else {
          this.loaderTab = true;
          let result = await new EVCStationReservationService().reservationsAccessibleByUserAtPageByPaginatedWithSizeMatchingQuery(
            new LocalStorage().user,
            this.pageNo,
            this.pageRecords,
            {
              id: this.id,
              station: {
                name: this.stationName,
              },
              customer: {
                name: this.customerName,
              },
              reservedBetween: {
                from: this.reservFrom ? new Date(this.reservFrom) : null,
                to: this.reservTo ? new Date(this.reservTo) : null,
              },
              types: null, // new EVChargingReservationTypeCode[{}](),
              status: new EVChargingReservationStatus(this.status, ""),
              invoicedBetween: {
                from: this.invoiceFrom ? new Date(this.invoiceFrom) : null,
                to: this.invoiceTo ? new Date(this.invoiceTo) : null,
              },
              invoiceNumber: this.invoiceNo,
            }
          );
          this.totalRecords = result.total;
          this.reservations = result.fetched;
          (this.pagesList = new PaginationUtils().getPagesList(
            this.totalRecords,
            this.pageRecords,
            this.pageNo
          )),
            (this.totalPages = new PaginationUtils().getTotalPages(
              this.totalRecords,
              this.pageRecords
            ));
          this.norecordsfound = false;
          this.loaderTab = false;
          new ToastUtils().presentToast("Search completed");
        }
      } catch(error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    },
    async loadPage(page) {
      try {
        localStorage.setItem("reservationPage", page);
        this.loaderTab = true;
        this.pageNo = page;
        this.pagesList = new PaginationUtils().getPagesList(
          this.totalRecords,
          this.pageRecords,
          page
        );
        let result = await new EVCStationReservationService().reservationsAccessibleByUserAtPageByPaginatedWithSizeMatchingQuery(
          new LocalStorage().user,
          this.pageNo,
          this.pageRecords,
          {
            id: this.id,
            station: {
              name: this.stationName,
            },
            customer: {
              name: this.customerName,
            },
            reservedBetween: {
              from: this.reservFrom ? new Date(this.reservFrom) : null,
              to: this.reservTo ? new Date(this.reservTo) : null,
            },
            types: null, //new EVChargingReservationTypeCode[{}],
            status: new EVChargingReservationStatus(this.status, ""),
            invoicedBetween: {
              from: this.invoiceFrom ? new Date(this.invoiceFrom) : null,
              to: this.invoiceTo ? new Date(this.invoiceTo) : null,
            },
            invoiceNumber: this.invoiceNo,
          }
        );
        this.totalRecords = result.total;
        this.reservations = result.fetched;
        this.loaderTab = false;
      }  catch(error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    },
  },
})
</script>

<style scoped>
.status-completed {
  background: #21b24b 0% 0% no-repeat padding-box;
  border-radius: 36px;
  padding-left: 5px;
  padding-top: 0px;
  padding-right: 5px;
  padding-bottom: 0px;
  text-align: left;
  font-family: "Roboto Medium";
  font-size: 13px;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
}

.status-cancelled {
  background: #a7a7a7 0% 0% no-repeat padding-box;
  border-radius: 36px;
  padding-left: 5px;
  padding-top: 0px;
  padding-right: 5px;
  padding-bottom: 0px;
  text-align: left;
  font-family: "Roboto Medium";
  font-size: 13px;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
}
.limit-length {
  width: 1% !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
</style>